import VersionManagerCore from '../versionManager.js';
import { pgVersionManager } from '../proGalleryVersionManager';

var SettingsVersionManager = /*#__PURE__*/function () {
  function SettingsVersionManager(proGallertVersionManager) {
    this.pgVersionManager = proGallertVersionManager || pgVersionManager;
  }

  var _proto = SettingsVersionManager.prototype;

  _proto.newMobileSettings = function newMobileSettings() {
    return this.pgVersionManager.getVersion('settings') !== VersionManagerCore.Versions.min;
  };

  return SettingsVersionManager;
}();

export default new SettingsVersionManager();